import React, { useState } from "react";
import { Container } from "reactstrap";
import ReturnManage from "./ReturnManage/ReturnManage";
import OrderTabs from "../../../../components/WholesalerComponents/OrderTabs/OrderTabs";
import RefundProcessing from "./RefundProcessing/RefundProcessing";
import ReturnAndRefundMetrics from "./ReturnAndRefundMetrics/ReturnAndRefundMetrics";
import PolicyGuidelines from "./PolicyGuidelines/PolicyGuidelines";

const ReturnsAndRefunds = () => {
  const tabs = [
    "Return Manage",
    "Refund Processing",
    "Return & Refund Metrices",
    "Policy Guidelines",
  ];
  const [activeTab, setActiveTab] = useState("Return Manage");

  return (
    <div
      style={{
        background: "#f2f2f2",
        minHeight: "100vh",
        padding: "20px",
      }}
    >
      <Container fluid className="p-0">
        <OrderTabs
          tabs={tabs}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />

        {activeTab === "Return Manage" && <ReturnManage />}
        {activeTab === "Refund Processing" && <RefundProcessing />}
        {activeTab === "Return & Refund Metrices" && <ReturnAndRefundMetrics />}
        {activeTab === "Policy Guidelines" && <PolicyGuidelines />}
      </Container>
    </div>
  );
};

export default ReturnsAndRefunds;